import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as actions from '../../../../services/actions';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireSelectionSensorType.module.scss';

const FormulaireSelectionSensorType = ({
  preconfigurerSensorTypeId,
  gererSensorTypeId,
}) => {
  const [sensorTypeId, setSensorTypeId] = useState(preconfigurerSensorTypeId);
  const dispatch = useDispatch();

  const listeSensorTypes = useSelector(
    (state) => state.capteur.sensor_types_list
  );

  useEffect(() => {
    dispatch(actions.reqRecupererListeSensorType());
  }, [dispatch]);

  useEffect(() => {
    if (preconfigurerSensorTypeId !== sensorTypeId) {
      setSensorTypeId(preconfigurerSensorTypeId);
    }
  }, [preconfigurerSensorTypeId, sensorTypeId]);

  const handleSensorTypeChange = (event) => {
    const newSensorType = event.target.value;
    setSensorTypeId(newSensorType);
    gererSensorTypeId(newSensorType);
  };

  return (
    <>
      <label className={styles.stile} htmlFor="sensorTypeSelect">
        {checkMot('capteur_type')}
      </label>
      {listeSensorTypes?.length > 0 ? (
        <select
          id="sensorTypeSelect"
          className={[s.custom_select, s.mr_sm_2, styles.text_geral].join(' ')}
          onChange={handleSensorTypeChange}
          value={sensorTypeId || ''}
        >
          <option value="">{checkMot('selectionne_type_capteur')}</option>
          {listeSensorTypes.map((sensorType) => (
            <option
              key={sensorType.sensor_type_id}
              value={sensorType.sensor_type_id}
            >
              {`id: ${sensorType.sensor_type_id}, name: ${sensorType.sensor_type_name}`}
            </option>
          ))}
        </select>
      ) : (
        <div>{checkMot('liste_capteur_pas_recupere_actuliser_page')}</div>
      )}
    </>
  );
};

export default FormulaireSelectionSensorType;
